import React from "react";
import { Strategy } from "src/common/Strategy";
import {
  LabelBuilderFn,
  LabelMakerDef,
  MakeLabelParams,
} from "./types/MakeLabelParams";
import { extractLabelViewFactors, genLabelKey } from "./utils/generateLabelKey";

export class StrategyInterpretView implements Strategy<React.ReactNode> {
  constructor(private readonly viewDefs: LabelMakerDef[]) {}

  params: MakeLabelParams | null = null;

  bind(params: MakeLabelParams) {
    this.params = params;
  }

  execute(): React.ReactNode {
    if (!this.params) {
      throw Error("systemError");
    }
    const { labelTreeData } = this.params;
    if (!labelTreeData) {
      throw Error("systemError");
    }

    const allVariations = this.viewDefs.map((e): [string, LabelBuilderFn] => [
      e.keygen(this.params!),
      e.label,
    ]);
    const map = new Map(allVariations.reverse());
    const possibleKeys = extractLabelViewFactors(this.params).map(genLabelKey);
    const firstHit = possibleKeys.find((key) => map.get(key));
    if (!firstHit) return null;
    const cmp = map.get(firstHit || "");
    return cmp?.(this.params) ?? null;
  }
}
